module.exports = ng.platformBrowser;